import React from 'react';
export const Header = () => {
  return <div className="flex justify-center py-6 sm:py-8" data-id="element-106">
      <img src="https://cdn.magicpatterns.com/uploads/pPv8sZAUYxABkDBucNAnxU/esa.png" alt="EquipSales Logo" className="h-16 sm:h-20 md:h-24" data-id="element-107" />
    </div>;
};